export enum SurveyStatus {
  // This survey is ready to be completed.
  ReadyToComplete = 'ReadyToComplete',

  // This survey has already been completed.
  Complete = 'Complete',

  // The deadline for this survey has passed.
  Expired = 'Expired'
}
